import http from "./http";
import { exportExcelService } from "./commonService"

var baseUrl="/appuser-web";

/* 组织管理相关*/
/* 获取组织列表 */
const getGovService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/org', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增组织 */
const addGovService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/org', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改组织 */
const modifyGovService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/org', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除组织 */
const deleteGovService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/org', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 根据组织查询部门列表 */
const getDeptListService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/org/dept/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 根据用户id查询组织id */
const getOrgIdService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/user/detail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 批量获取用户签名 */
const getsignUrlApi = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/user/batch/getSignUrl', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 
** 获取项目经理下拉列表 gaa 20200916
*/
const getProjectGMListService = (deptCode) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/user/dept',deptCode, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}



/* 部门管理相关*/
/* 获取部门列表 */
const getDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增部门 */
const addDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/dept', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改部门 */
const modifyDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/dept', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除部门 */
const deleteDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/dept', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//获取有效子部门列表
const getsubDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/dept/sub/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 获取OTA配置列表*/
const getOtaPageListService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-ota/otaManage/getPageList', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取OTA配置详情*/
const getAppVersionService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-ota/otaManage/getAppVersion', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 启用OTA配置*/
const setAppVersionService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-ota/otaManage/setAppVersion', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增OTA配置*/
const addAppVersionService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-ota/otaManage/addAppVersion', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改OTA配置*/
const modifyAppVersionService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-ota/otaManage/modifyAppVersion', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}



/*区域归属列表 */
const selectAreaGroup = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-repair/areaGroup/selectAreaGroup', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/*获取区域归属列表 */
const getAreaGroup = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-repair//areaGroup/selectAreaGroup', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 新增区域 */
const addAreaGroup = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-property-repair//areaGroup/addAreaGroup', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 废弃区域 */
const delAreaGroup = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-property-repair/areaGroup/delAreaGroup', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//消息相关接口 20200910
/* 获取消息列表*/
const getLatestMessageList = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/msg/list', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/*消息设置为已读 */
const readMsg = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/msgManage/readMsg', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/*全部消息设置为已读 */
const readAllMsg = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/msgManage/readAllMsg', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//删除消息
const deleteBatchService=(reqParam)=>{
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/msg/batch', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });

}
//查询未读公文消息数量
const getUnreadLatestFileCount = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/msg/file/count', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取公文消息列表*/
const getLatestFileList = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/msg/file/list', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//公文消息置为已读
const readDocumentMsg = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/appuser-web/msg/file/check', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//删除公文消息
const deleteDocumentService=(reqParam)=>{
    return new Promise((resolve, reject) => {
        http.delete('/appuser-web/msg/file', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });

}

// 获取未读工单通知
const getComplTotal = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-property-repair/complQuery/getComplTotal/pc', reqParam).then(result => {
            result.resultCode == '0' ? resolve(result.data) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })
    });
}
//获取未读发现信息
const getCountNoCatNote = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-discovery-forum/reminder/countNoCatNote', reqParam).then(result => {
            result.resultCode == '0' ? resolve(result.data) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })
    });
}

//获取发现未读消息 GET /note/getRedNotice
const getRedNotice = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-discovery-forum/note/getRedNotice', reqParam).then(result => {
            result.resultCode == '0' ? resolve(result.data) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })
    });
}


/*********************** 菜单相关 ***********************/
/* 获取所有菜单列表*/
const getAllMenuService = () => {
    let params = { operationFlag: "0,3" }
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userMenuManage/getAllMenu', params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 获取用户所有菜单列表*/
const getAllMenuByUserCodeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/menu/buildTree', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 获取菜单详情*/
const getMenuDetailsService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/menu/detail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 新增菜单*/
const addNewMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/menu', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改菜单详情*/
const modifyMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/menu', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 删除菜单*/
const deleteMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/menu', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取菜单按钮列表*/
const getMenuBtnListService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userMenuManage/getMenuBtnList', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取菜单按钮详情*/
const getMenuBtnDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userMenuManage/getMenuBtnDetail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增菜单按钮*/
const addMenuBtnService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/menu/permission', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改菜单按钮*/
const updateMenuBtnService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/menu/permission', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除菜单按钮*/
const deleteMenuBtnService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/menu/permission', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取用户授权菜单列表*/
const getUserMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userMenuManage/getUserMenu', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/*********************** 组织架构相关 ***********************/
/* 获取组织架构树*/
const getDeptMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/organize/getOrganizeDepartmentTreeByUserCode', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取公司详情*/
const getDeptInfoService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/organize/getDeptInfo', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// /* 新增公司节点*/
// const addDeptService = (reqParam) => {
//     return new Promise((resolve, reject) => {
//         http.post('/xwj-sys-user/organize/addDept', reqParam, false).then(result => {
//             resolve(result);
//         }).catch(error => {
//             reject(error);
//         })
//     });
// }

/* 修改公司节点*/
const updDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/organize/updDept', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除公司节点*/
const delDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/organize/delDept', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/*********************** 角色权限相关 ***********************/

/* 获取组织树*/
const getDepartmentTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/organize/getOrganizeDepartmentTreeByUserCode', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 获取用户授权的组织*/
const getUserDepartmentService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/organize/getUserDepartment', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 用户组织授权*/
const addUserDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userManage/addUserDept', reqParam, false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/*********************** 岗位相关 ***********************/
/* 获取岗位列表*/
const manangerStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/job', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取岗位详情*/
const stationDetailsService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/stationDetails', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增岗位*/
const insertStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/job', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改岗位*/
const modifyStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/job', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 删除岗位*/
const deleteStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/job', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取岗位树*/
const getStationTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/getStationTree', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取用户授权岗位*/
const getUserStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/getUserstation', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 设置用户授权岗位*/
const updateUserStationService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userStationManage/updateUserStation', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 获取小区岗位*/
const getAreaPostInfosService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/getPostInfos', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 设置小区岗位*/
const addAreaPostService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userStationManage/addPost', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 修改小区岗位*/
const modifyAreaPostService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-property-repair/postUser/modifyParentPost', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 修改小区岗位*/
const deletePostService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userStationManage/deletePost', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/*********************** 角色相关 ***********************/
/* 获取角色列表*/
const getAllRolesService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userRoleManage/getRolesByUserCode', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取用户可授权的角色列表*/
const getEditRolesByUserCodeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/role', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取角色授权的菜单列表*/
const getRoleAssignMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/role/menu/permission/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 新增角色*/
const addRoleService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/role', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改角色*/
const modifyRoleService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/role', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除角色*/
const deleteRoleService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/role', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 角色授权菜单*/
const changeRoleMenuService = (reqParam,roleId) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/role/menu/permission?roleId='+roleId, reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 角色授权用户*/
const authRoleUserService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userManage/authRole', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取角色授权的菜单按钮*/
const getGrantMenuBtnService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/role/permission', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 用户角色授权*/
const addUserRoleService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/userManage/addUserRole', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取角色可授权用户列表*/
const getAccountRolePageService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userRoleManage/getAccountByRoleCode', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取角色已授权用户列表*/
const getRoleAssginUserCurrentPageeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userRoleManage/getRoleAssginUserCurrentPage', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/*********************** 数据字典相关 ***********************/
/* 获取数据字典列表*/
const BasicDataService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDict', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取数据字典详情*/
const BasicDataDetailsService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDict/detail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增数据字典*/
const insertBasicDataService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/sysDict', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改数据字典*/
const modifyBasicDataService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/sysDict', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 删除数据字典*/
const deleteBasicDataService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/sysDict', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取数据字典详情列表*/
const BasicDataDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDictDetail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取二级数据字典详情列表*/
const BasicDataTwoDetailsService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDictDetail/subLevel', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增数据字典详情列表中的一项数据*/
const insertBasicDataDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/sysDictDetail', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 根据key查询字典详情列表*/
const getsysDictDetailApi = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDictDetail/sysDictDetail/common', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改数据字典详情中的一项数据*/
const modifyBasicDataDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/sysDictDetail', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 删除数据字典详情中的一项数据*/
const deleteBasicDataDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/sysDictDetail', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 查询审批流二级字典详情*/
const selectSecondDataDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/sysDictDetail/approveflow/subLevel', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 审批流相关接口  */

//获取tabs页相关接口
const getApproveTabsService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/approve/type/dict/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//查询审批流接口
const getApproveListService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/approve/detail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });

    // return new Promise((resolve, reject) => {
    //   let test1 = {
    //     "code": 10000000,
    //     "msg": "调用成功",
    //     "data": [
    //       {
    //         "name": null,
    //         "type": "meetingbill",
    //         "subType": null,
    //         "orgId": 1,
    //         "jobId": 10,
    //         "sortId": 1,
    //         "jobName": "测试人员"
    //       },
    //       {
    //         "name": null,
    //         "type": "meetingbill",
    //         "subType": null,
    //         "orgId": 1,
    //         "jobId": 4,
    //         "sortId": 2,
    //         "jobName": "岗位1"
    //       }
    //     ],
    //     "total": null,
    //     "msgParam": null
    //   }

    //   let test2 = {
    //     "code": 10000000,
    //     "msg": "调用成功",
    //     "data": [
    //       {
    //         "name": null,
    //         "type": "meetingbill",
    //         "subType": null,
    //         "orgId": 1,
    //         "jobId": 12,
    //         "sortId": 1,
    //         "jobName": "哈哈"
    //       },
    //       {
    //         "name": null,
    //         "type": "meetingbill",
    //         "subType": null,
    //         "orgId": 1,
    //         "jobId": 13,
    //         "sortId": 2,
    //         "jobName": "来吧"
    //       }
    //     ],
    //     "total": null,
    //     "msgParam": null
    //   }


    //   console.log('收到的参数', reqParam)

    //   if(reqParam.subType == 'class1') {
    //     resolve(test1)
    //   } else {
    //     resolve(test2)
    //   }
      
      
    // })
}

/* 新建审批流接口*/
const addApproveService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/approve', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 清空审批流接口
const clearApproveService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+'/approve', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

/*********************** 设置管理相关 ***********************/
/* 获取业主小区列表*/
const getAreaInfoService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/area/getAreaInfo', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 获取小区配置的应用列表*/
const getAreaAppService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-set/homeNoticeManage/getAreaApp', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 修改小区配置*/
const addAppConfigService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-set/homeNoticeManage/addAppConfig', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 区域归属管理列表 */
const getAreasForGroup = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-property-repair/areaGroup/selectAreasForGroup', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 设置区域归属 */
const updateGroupForArea = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('xwj-property-repair/areaGroup/updateGroupForArea', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取下级区域 */
const getListAreasByDeptCode = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-property-house/house/area/getListAreasByDeptCode', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 多组织权限维护 */
/* 分页查询所有一级组织列表 */
const getOneLevelDeptService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/getOneLevelDept', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 查询所有菜单树 gaa 20200831*/
const getDeptAssginMenuTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/menu/listTree', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 查询菜单按钮 */
const getDeptGrantMenuBtnTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/menu/permission', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//获取按钮名称下拉列表 
const getButtonNamesService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/menu/permission/dict/list', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//区域管理
//获取省
const getProvinceService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/area/province', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//获取市区
const getCityService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/area/city', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//规章制度相关接口
//查询通知公告类型
const getRuleService = () => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/base/notice/type/dict/list').then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//查询通知公告详情
const getRuleDetailService = (param) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/base/notice/detail',{"businessType":param}).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//更新通知公告
const updateRuleDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/base/notice', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}






/* 查询组织已经分配的菜单树 */
const getRoleDeptAssginMenuTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/getDeptAssginMenuTree', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 查询组织已授权菜单按钮树 */
const getRoleDeptGrantMenuBtnTreeService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/getDeptGrantMenuBtnTree', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 查询组织已经分配的菜单编码 */
const getDeptAssginMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/getDeptAssginMenu', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 查询组织已授权菜单按钮编码 */
const getDeptGrantMenuBtnService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/getDeptGrantMenuBtn', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/* 组织授权保存 */
const changeDeptMenuService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('xwj-sys-user/organize/changeDeptMenu', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取公司对应的一级组织的第三方编码类型 */
const getCompanyPartnerType = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('xwj-sys-user/organize/queryPartnerTypeByDeptCode', reqParam,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 上传电子签名图片
const uploadSignService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(baseUrl + "/oss/upload/user/sign", param, false, true, true)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const queryRealApproveProcessApi = (params) => {
    return new Promise((resolve, reject) => {
      http.get("/common-web/approve/queryRealApproveProcess", params, true).then(result => {
        resolve(result);
      }).catch(error => {
        reject(error)
      })
    })
  }
    // 查询分项合同打印部门
  const queryPrintdeptApi = (params) => {
    return new Promise((resolve, reject) => {
      http.get("/appuser-web/sysDictDetail/subcontract/printdept/dict/list", params, true).then(result => {
        resolve(result);
      }).catch(error => {
        reject(error)
      })
    })
  }


export {
    queryRealApproveProcessApi,
    uploadSignService,
    getGovService,   //组织列表
    addGovService,  //添加组织
    modifyGovService,  //修改组织
    deleteGovService,   //删除组织

    getDeptService,   //部门列表
    addDeptService,  //添加部门
    modifyDeptService,  //修改部门
    deleteDeptService,   //删除部门
    getsubDeptService,   //获取子部门列表
    getDeptListService,   //根据组织查询部门
    getOrgIdService,   //根据用户id查询组织id
    BasicDataService,  //获取数据字典列表
    getsignUrlApi,
    BasicDataDetailsService,   //获取数据字典详情
    insertBasicDataService,   //新增数据字典
    modifyBasicDataService,   //修改数据字典
    deleteBasicDataService,   //删除数据字典

    BasicDataDetailService,   //获取数据字典详细列表数据
    BasicDataTwoDetailsService,   //获取二级数据字典内容
    insertBasicDataDetailService,   //新增数据字典详情列表中的一项数据
    getsysDictDetailApi,
    getProjectGMListService,   //获取部门下人员列表
    modifyBasicDataDetailService,
    deleteBasicDataDetailService,
    selectSecondDataDetailService, //查询审批流二级字典详情

    getApproveTabsService,   //获取审批流tab页标签
    getApproveListService,    //查询审批流
    addApproveService,         //保存审批流
    clearApproveService,         //清空审批流

    getButtonNamesService,   //查询全部菜单名称下拉列表
    getProvinceService,   //查询省列表
    getCityService,      //查询市区列表

    getRuleService,    //查询通知公告类型
    getRuleDetailService,  //查询通知公告详情
    updateRuleDetailService,   //更新通知公告



    getOtaPageListService,
    getAppVersionService,
    setAppVersionService,
    modifyAppVersionService,
    addAppVersionService,
    getLatestMessageList,
    selectAreaGroup,
    readMsg,
    readAllMsg,
    deleteBatchService,  //删除
    getLatestFileList,//查询公文消息列表
    deleteDocumentService,//删除公文消息
    getUnreadLatestFileCount,
    readDocumentMsg,
    getAreaGroup,
    getAllMenuService,
    getAllMenuByUserCodeService,
    getMenuDetailsService,
    addNewMenuService,
    modifyMenuService,
    deleteMenuService,
    getMenuBtnListService,
    getMenuBtnDetailService,
    addMenuBtnService,
    updateMenuBtnService,
    deleteMenuBtnService,
    getUserMenuService,
    getDeptMenuService,
    getDeptInfoService,
    // addDeptService,
    updDeptService,
    delDeptService,
    addAreaGroup,
    delAreaGroup,
    getDepartmentTreeService,
    getUserDepartmentService,
    addUserDeptService,
    manangerStationService,
    stationDetailsService,
    insertStationService,
    modifyStationService,
    deleteStationService,
    getStationTreeService,
    getUserStationService,
    updateUserStationService,
    getAreaPostInfosService,
    addAreaPostService,
    modifyAreaPostService,
    deletePostService,
    getAllRolesService,
    getEditRolesByUserCodeService,
    getRoleAssignMenuService,
    addRoleService,
    modifyRoleService,
    deleteRoleService,
    changeRoleMenuService,
    authRoleUserService,
    getGrantMenuBtnService,
    addUserRoleService,
    getRoleAssginUserCurrentPageeService,
    getAccountRolePageService,
    getAreaInfoService,
    getAreaAppService,
    addAppConfigService,
    getAreasForGroup,
    updateGroupForArea,
    getListAreasByDeptCode,
    getComplTotal,
    getCountNoCatNote,
    getRedNotice,
    getOneLevelDeptService, getDeptAssginMenuTreeService, getDeptGrantMenuBtnTreeService,getRoleDeptAssginMenuTreeService,getRoleDeptGrantMenuBtnTreeService, getDeptAssginMenuService, getDeptGrantMenuBtnService, changeDeptMenuService,
    getCompanyPartnerType,
    queryPrintdeptApi
}